"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformVehicleDataToVehicleInfo = void 0;
const legacy_models_1 = require("@daytrip/legacy-models");
const transformVehicleDataToVehicleInfo = (vehicle, model, make) => {
    const info = new legacy_models_1.VehicleInfo();
    info._id = vehicle._id;
    info.title = `${make.name} ${model.name}`;
    info.manufactureYear = vehicle.manufactureYear;
    info.seatsCount = model.seatsCount;
    info.isLuxury = model.isLuxury;
    info.color = vehicle.color;
    info.ownerUserId = vehicle.ownerUserId;
    info.approvedForCountryIds = model.approvedForCountryIds;
    info.luxuryForCountryIds = model.luxuryForCountryIds;
    info.licencePlate = vehicle.licensePlate;
    info.status = vehicle.status;
    return info;
};
exports.transformVehicleDataToVehicleInfo = transformVehicleDataToVehicleInfo;
//# sourceMappingURL=transformVehicleDataToVehicleInfo.js.map